// Boat Classes - shared across all components
// Shell types for on-water rowing (used for equipment management - not gendered)
export const SHELL_CLASSES = [
  { value: '1x', label: '1x (Single)' },
  { value: '2x', label: '2x (Double)' },
  { value: '2-', label: '2- (Pair)' },
  { value: '2x/-', label: '2x/- (Pair/Double)' },
  { value: '4x', label: '4x (Quad)' },
  { value: '4-', label: '4- (Four)' },
  { value: '4x/-', label: '4x/- (Coxless Four/Quad)' },
  { value: '4+', label: '4+ (Coxed Four)' },
  { value: '4+/x', label: '4+/x (Coxed Four/Quad)' },
  { value: '8+', label: '8+ (Eight)' },
];

// Equipment classes that are not rowing shells
export const EQUIPMENT_CLASSES = [
  { value: 'Erg', label: 'Erg (Rowing Machine)' },
  { value: 'Launch', label: 'Launch (Motorized Boat)' },
];

// Oar types
export const OAR_TYPES = [
  { value: 'Sweep', label: 'Sweep Oars' },
  { value: 'Scull', label: 'Sculling Oars' },
  { value: 'Coxbox', label: 'Coxbox' },
];

// All equipment classes (shells + equipment like ergs)
export const ALL_EQUIPMENT_CLASSES = [...SHELL_CLASSES, ...EQUIPMENT_CLASSES];

// Erg classes for athlete results (gendered for GMS tracking)
export const ERG_RESULT_CLASSES = [
  { value: "M Erg", label: "M Erg" },
  { value: "W Erg", label: "W Erg" },
];

// Gendered shell classes for athlete results (for GMS tracking)
export const GENDERED_SHELL_CLASSES = [
  { value: "M 1x", label: "M 1x (Single)" },
  { value: "W 1x", label: "W 1x (Single)" },
  { value: "M 2x", label: "M 2x (Double)" },
  { value: "W 2x", label: "W 2x (Double)" },
  { value: "M 2-", label: "M 2- (Pair)" },
  { value: "W 2-", label: "W 2- (Pair)" },
  { value: "M 4x", label: "M 4x (Quad)" },
  { value: "W 4x", label: "W 4x (Quad)" },
  { value: "M 4-", label: "M 4- (Four)" },
  { value: "W 4-", label: "W 4- (Four)" },
  { value: "M 4+", label: "M 4+ (Coxed Four)" },
  { value: "W 4+", label: "W 4+ (Coxed Four)" },
  { value: "M 8+", label: "M 8+ (Eight)" },
  { value: "W 8+", label: "W 8+ (Eight)" },
];

// All boat classes for athlete results (gendered shells + ergs for GMS tracking)
export const ALL_BOAT_CLASSES = [...GENDERED_SHELL_CLASSES, ...ERG_RESULT_CLASSES];

// Helper to check if equipment is an erg (no meters/reservations, only damage reports)
export const isErgEquipment = (boatClass) => boatClass === 'Erg';

// Helper to check if equipment is a launch (reservable, damage reports, no meters)
export const isLaunchEquipment = (boatClass) => boatClass === 'Launch';

export const tracksMeters = (boatClass) => Boolean(boatClass) && !isErgEquipment(boatClass) && !isLaunchEquipment(boatClass);

export const isReservableClass = (boatClass) => Boolean(boatClass) && !isErgEquipment(boatClass);

export const isRowingShell = (boatClass) => tracksMeters(boatClass);

// Helper to check if oar type needs a pair (sweep) vs individual (scull)
export const isSweepOar = (oarType) => oarType === 'Sweep';

// Simple array of shell class values (for backwards compatibility)
export const SHELL_CLASS_VALUES = SHELL_CLASSES.map(c => c.value);

// Simple array of all boat class values (for backwards compatibility)
export const BOAT_CLASS_VALUES = ALL_BOAT_CLASSES.map(c => c.value);

// Ungendered classes used for per-athlete 2k goals (Korzo prognostic).
export const GOAL_2K_BOAT_CLASSES = [
  { value: 'Erg', label: 'Erg' },
  { value: '1x', label: '1x (Single)' },
  { value: '2x', label: '2x (Double)' },
  { value: '2-', label: '2- (Pair)' },
  { value: '4x', label: '4x (Quad)' },
  { value: '4-', label: '4- (Four)' },
  { value: '4+', label: '4+ (Coxed Four)' },
  { value: '8+', label: '8+ (Eight)' }
];

// Helper function to get label from value
export const getBoatClassLabel = (value) => {
  const boatClass = ALL_BOAT_CLASSES.find(c => c.value === value);
  return boatClass ? boatClass.label : value;
};

export default {
  SHELL_CLASSES,
  EQUIPMENT_CLASSES,
  ALL_EQUIPMENT_CLASSES,
  ERG_RESULT_CLASSES,
  GENDERED_SHELL_CLASSES,
  ALL_BOAT_CLASSES,
  SHELL_CLASS_VALUES,
  BOAT_CLASS_VALUES,
  GOAL_2K_BOAT_CLASSES,
  OAR_TYPES,
  getBoatClassLabel,
  isErgEquipment,
  isLaunchEquipment,
  tracksMeters,
  isReservableClass,
  isRowingShell,
  isSweepOar,
};

